import { merge } from '../../helper';

import * as exElement from '../element';
import type { IElementConfig } from '../element/types';

// ----------------------------------------------------------------------------

export interface ILayoutConfig extends IElementConfig {
    prefix?: string;
    layoutLeft?: IElementConfig;
    layoutMiddle?: IElementConfig;
    layoutRight?: IElementConfig;
}

export type TypeLayoutReturn = {
    element: HTMLElement;
    elements: {
        element: HTMLElement;
        layoutLeft: HTMLElement;
        layoutMiddle: HTMLElement;
        layoutRight: HTMLElement;
    };
};

// ----------------------------------------------------------------------------

function create(config: ILayoutConfig = {}): TypeLayoutReturn {
    const defConfig: ILayoutConfig = {
        prefix: 'layout',
    };

    merge(defConfig, config);

    // ------------------------------------------------------------------------

    const build = {
        elements: {},
    } as TypeLayoutReturn;

    // ------------------------------------------------------------------------

    const elRoot = exElement.create({
        merge: defConfig,
        class: { new: `${defConfig.prefix}` },
    });
    build.element = elRoot;
    build.elements.element = elRoot;

    // ------------------------------------------------------------------------

    const elLeft = exElement.create({
        merge: defConfig.layoutLeft,
        class: { new: `${defConfig.prefix}-left` },
    });
    elRoot.appendChild(elLeft);
    build.elements.layoutLeft = elLeft;

    // ------------------------------------------------------------------------

    const elMiddle = exElement.create({
        merge: defConfig.layoutMiddle,
        class: { new: `${defConfig.prefix}-middle` },
    });
    elRoot.appendChild(elMiddle);
    build.elements.layoutMiddle = elMiddle;

    // ------------------------------------------------------------------------

    const elRight = exElement.create({
        merge: defConfig.layoutRight,
        class: { new: `${defConfig.prefix}-right` },
    });
    elRoot.appendChild(elRight);
    build.elements.layoutRight = elRight;

    // ------------------------------------------------------------------------

    return build;
}

// ----------------------------------------------------------------------------

export { create };
